const own = (value, key) => Object.prototype.hasOwnProperty.call(value || {}, key)
const number = value => ['number', 'string'].includes(typeof value) && String(value).trim() !== '' && Number.isFinite(Number(value)) ? Number(value) : null

export function hasGaugeDataOverrides (option = {}) {
  return ['gaugeMin', 'gaugeMax'].some(key => own(option, key) && number(option[key]) !== null) || typeof option.gaugeLabel === 'string'
}

// 显式外观配置独立于接口/WS数据，设备推送或 formatter 不能覆盖用户设置的量程和名称。
export function gaugeDisplayData (data = {}, option = {}) {
  const result = { ...(data && typeof data === 'object' && !Array.isArray(data) ? data : {}) }
  for (const [key, target] of [['gaugeMin', 'min'], ['gaugeMax', 'max']]) {
    if (own(option, key) && number(option[key]) !== null) result[target] = Number(option[key])
  }
  if (typeof option.gaugeLabel === 'string') result.label = result.name = option.gaugeLabel
  return result
}

export function gaugeRangeIssue (data, option) {
  const display = gaugeDisplayData(data, option)
  const min = number(display.min === undefined ? 0 : display.min), max = number(display.max === undefined ? 100 : display.max)
  return min === null || max === null ? '仪表盘量程必须为有效数值' : min >= max ? '仪表盘最小值必须小于最大值' : ''
}
